// Label in Name (WCAG 2.5.3): a control's accessible name must contain the text
// shown on it, so voice-control users can say what they see ("click Click
// Here"). Some authored links carry an aria-label that replaces the visible
// words (e.g. visible "Click Here", aria-label "Assam Flood Claim Support").
// For those, the visible text is put at the start of the name:
// "Click Here: Assam Flood Claim Support". Nothing visible changes.
const CONTROLS = "a[aria-label], button[aria-label], [role='button'][aria-label], [role='link'][aria-label]";

const normalise = (text) => (text || "").toLowerCase().replace(/[^a-z0-9ऀ-ॿ]+/g, " ").trim();

function fixLabels(scope) {
    scope.querySelectorAll(CONTROLS).forEach((control) => {
        const visible = (control.innerText || "").replace(/\s+/g, " ").trim();
        const label = control.getAttribute("aria-label");
        if (!visible || visible.length < 2 || normalise(label).includes(normalise(visible))) {
            return;
        }
        control.setAttribute("aria-label", `${visible}: ${label}`);
    });
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => fixLabels(document));
} else {
    fixLabels(document);
}
